const caixaAccountType = (value) => {
  // The 001, 013 and 023 savings account types have been discontinued.
  if (!value || value === '001' || value === '013' || value === '023') {
    return false;
  }
  return true;
};

export default caixaAccountType;
